/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Prepose
 * 2 = EC
 * 3 = CourrierSensibilisation
 * 4 = CourrierAvertissement
 * 5 = CourrierExclusionTemporaire
 * 6 = CourrierExclusionDefinitive
 * 7 = DepotPlainte
 */
export enum TypePieceJointeValues {
  Prepose = 1,
  EC = 2,
  CourrierSensibilisation = 3,
  CourrierAvertissement = 4,
  CourrierExclusionTemporaire = 5,
  CourrierExclusionDefinitive = 6,
  DepotPlainte = 7
}
